<template>
  <h3
    class="title-center-container"
    :id="content.key"
    :style="{
      fontFamily: content.textStyle.fontFamily || '',
      fontSize: (content.textStyle.fontSize + 'rem') || '',
      lineHeight: (content.textStyle.lineHeight + 'rem') || '',
      textIndent: (typeof content.textStyle.textIndent === 'string') ? content.textStyle.textIndent :
        (typeof content.textStyle.textIndent === 'number') ? (content.textStyle.textIndent + 'rem') : '',
      fontWeight: content.textStyle.fontWeight || '',
      textDecoration: content.textStyle.underline === 1 ? 'underline' : '',
      fontStyle: content.textStyle.fontItalic === 1 ? 'italic' : '',
      textAlign: content.textStyle.textAlign || '',
      color: content.textStyle.color || '',
      backgroundColor: content.textStyle.backgroundColor || '',
      backgroundImage: content.textStyle.backgroundImage ? `url(${content.textStyle.backgroundImage})` : '',
    }"
  >
    <span class="title-text" :id="`${content.key}-1`">
      <span :id="`${content.key}-1-1`" v-html="content.shortText"></span>
      <span :id="`${content.key}-1-2`" v-html="content.text"></span>
    </span>
  </h3>
</template>
<script>
/*
标题 - 文字居中 带背景图
*/
export default {
  name: "title-center",
  props: {
    content: {
      type: Object,
      default: () => {
        return {};
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.title-center-container{
  margin-top: 20rem;
  width: 100%;
  height: 69rem;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 32rem;
  color: #fff;
  font-weight: bold;
  text-indent: 0;

  .title-text{
    text-align: center;
    display: block;
  }
}
</style>